export enum ENVIRONMENTS {
  NONE = 'none',
  TEST1 = 'test1',
  TEST2 = 'test2',
  TEST3 = 'test3',
  TEST4 = 'test4',
  TEST5 = 'test5',
  UAT = 'uat',
  PROD = 'prod',
  LOCAL = 'local',
}

export enum AEM_MODES {
  PUBLISH = 'publish',
  PREVIEW = 'preview',
}

export interface SearchPanelConfig {
  hideSearchPanel: boolean;
  destination?: string | null;
  bookingType?: string | null;
}

export const isPreviewMode =
  (process.env.NEXT_PUBLIC_AEM_MODE || '').toLowerCase() === AEM_MODES.PREVIEW;

export const assetPath = isPreviewMode ? '/preview/' : '';

const validEnvironments = new Set<string>(Object.values(ENVIRONMENTS));

const normaliseEnvironmentName = (
  environmentName: string | undefined,
): ENVIRONMENTS => {
  const normalisedEnvironmentName = (environmentName || '')
    .trim()
    .toLowerCase()
    .replace(/-(preview|publish)$/, '');

  if (normalisedEnvironmentName === 'grn') {
    return ENVIRONMENTS.PROD;
  }

  if (validEnvironments.has(normalisedEnvironmentName)) {
    return normalisedEnvironmentName as ENVIRONMENTS;
  }

  return ENVIRONMENTS.NONE;
};

export const currentEnvironment = normaliseEnvironmentName(
  process.env.NEXT_PUBLIC_ENVIRONMENT_NAME,
);

export const isLocal = currentEnvironment === ENVIRONMENTS.LOCAL;
